{
  "startYear": 2022,
  "endYear": 2026,
  "lanes": [
    {
      "id": "VISION",
      "label": "Vision",
      "y": 140,
      "color": "#5236ab"
    },
    {
      "id": "PROCESS",
      "label": "Process",
      "y": 220,
      "color": "#9ca3af"
    },
    {
      "id": "RND",
      "label": "R&D",
      "y": 300,
      "color": "#ff4d7a"
    },
    {
      "id": "TEAM",
      "label": "Team",
      "y": 380,
      "color": "#f97316"
    },
    {
      "id": "FLAGSHIP",
      "label": "Flagship",
      "y": 460,
      "color": "#00a1b2"
    },
    {
      "id": "INTERNAL",
      "label": "Internal",
      "y": 540,
      "color": "#4b5563"
    },
    {
      "id": "COMMERCIAL",
      "label": "Commercial",
      "y": 620,
      "color": "#1f9d55"
    }
  ],
  "milestones": [
    {
      "id": "SMTX-TXCL",
      "level": "subitem",
      "title": "Valmet Smart Ticketing",
      "year": 2022,
      "quarter": "Q4",
      "month": 2,
      "week": 3,
      "lane": "INTERNAL",
      "description": "Internal foundation work around smart ticketing concepts that later influence Valmet’s automation and predictive intelligence journey. It focuses on improving ticket routing, classification and downstream analytics readiness.\n",
      "branchOnly": false,
      "parent": "FIRSTPOC"
    },
    {
      "id": "2022-Q4-fy23-leadership-connect",
      "level": "goal",
      "title": "FY23 Leadership Connect",
      "year": 2022,
      "quarter": "Q4",
      "month": 3,
      "week": 3,
      "lane": "VISION",
      "description": "A leadership forum to communicate the evolving automation and AI roadmap, successes and upcoming bets. It reinforces sponsorship, secures support for strategic investments and aligns expectations across stakeholders.\n",
      "branchOnly": false,
      "parent": "START"
    },
    {
      "id": "START",
      "level": "goal",
      "title": "King's Gambit",
      "year": 2022,
      "quarter": "Q3",
      "month": 5,
      "week": 1,
      "lane": "VISION",
      "image": "cloning-expert.svg",
      "description": "A metaphorical opening move that marks the decision to build an AI-ready D&AS team and portfolio. It frames the long-term vision of turning experimentation into commercial automation offerings for the business.\n",
      "branchOnly": false,
      "parent": "2022-Q4-fy23-leadership-connect"
    },
    {
      "id": "EXPERT",
      "level": "goal",
      "title": "Expert's Call",
      "year": 2022,
      "quarter": "Q4",
      "month": 6,
      "week": 1,
      "laneLevel": 3,
      "lane": "TEAM",
      "description": "A structured assessment of team competencies across languages, methodologies, domains, tools, infrastructure and AI fundamentals. The outcome is a clear view of strengths and gaps that will guide training, hiring and role specialization.\n",
      "branchOnly": false,
      "parent": "START"
    },
    {
      "id": "TECH-GAPS",
      "level": "goal",
      "title": "Expert's Technical  - Gap Analysis",
      "year": 2022,
      "quarter": "Q4",
      "month": 7,
      "week": 2,
      "lane": "PROCESS",
      "description": "A holistic review of local dev environments, linting, version control, CI/CD, cloud sandboxes and dependency management. It identifies where tooling, standards and practices fall short so they can be hardened for scalable AI and automation delivery.\n",
      "branchOnly": false,
      "parent": "EXPERT"
    },
    {
      "id": "TECH-AUDIT",
      "level": "goal",
      "title": "Expert's Technical - Audit On Going Projects",
      "year": 2022,
      "quarter": "Q4",
      "month": 7,
      "week": 2,
      "lane": "INTERNAL",
      "description": "A deep-dive audit of active repositories, branching strategies, documentation, estimation, and DevOps practices against modern standards. The exercise surfaces concrete remediation steps around linting, testing, code review, release management and project kickoff discipline.\n",
      "branchOnly": false,
      "parent": "EXPERT"
    },
    {
      "id": "FIRSTPOC",
      "level": "goal",
      "title": "Expert's Showcase - Building D&AS AI Portfolio",
      "year": 2022,
      "quarter": "Q4",
      "month": 8,
      "week": 1,
      "laneLevel": 1,
      "lane": "INTERNAL",
      "description": "The First POC: Voice Controlled PowerBI Dashboard - A pre-GPT proof of concept combining intent and entity recognition with Alexa voice models to control a Power BI dashboard. It demonstrates the potential of voice-first analytics and sets the tone for future multimodal AI experiments.\n",
      "branchOnly": false,
      "parent": "EXPERT"
    },
    {
      "id": "TECH-LANG",
      "level": "goal",
      "title": "From JavaScript to TypeScript",
      "year": 2022,
      "quarter": "Q4",
      "month": 8,
      "week": 1,
      "lane": "PROCESS",
      "branchOnly": true,
      "description": "A strategic move from untyped JavaScript to TypeScript to catch defects at compile time and improve maintainability. Strong typing, better IDE support and clearer contracts accelerate collaboration across teams and complex solutions.\n",
      "parent": "TECH-GAPS"
    },
    {
      "id": "TECH-FRAMEWORK",
      "level": "goal",
      "title": "Angular to React",
      "year": 2022,
      "quarter": "Q4",
      "month": 8,
      "week": 1,
      "lane": "PROCESS",
      "branchOnly": true,
      "description": "A shift from a monolithic Angular framework to a lighter, component-based React architecture. This enables more modular UI development, easier embedding into existing portals and better reuse across projects.\n",
      "parent": "TECH-LANG"
    },
    {
      "id": "TECH-COURSE",
      "week": 1,
      "month": 8,
      "level": "goal",
      "title": "Programming Foundations – Core Courses",
      "year": 2022,
      "quarter": "Q4",
      "lane": "TEAM",
      "description": "A structured curriculum covering core programming topics such as data structures, algorithms, error handling and design patterns. It brings interns and junior engineers up to a consistent baseline so they can contribute to production-grade solutions. Internal Training, Internship to Hire Program, and Bench Retooling utilize this course.\n",
      "branchOnly": false,
      "parent": "TECH-GAPS"
    },
    {
      "id": "TECH-GIT",
      "week": 2,
      "month": 8,
      "level": "subitem",
      "title": "Version Control with Git – Branching, PRs and Workflows",
      "year": 2022,
      "quarter": "Q4",
      "lane": "TEAM",
      "description": "Training and enablement around Git fundamentals, including branching strategies, pull requests and code review workflows. The goal is to normalize modern source control habits across all D&AS projects and reduce integration chaos.\n",
      "branchOnly": true,
      "parent": "TECH-COURSE"
    },
    {
      "id": "TECH-STD",
      "week": 2,
      "month": 8,
      "level": "subitem",
      "title": "Standardization of Tools, Libraries and Practices",
      "year": 2022,
      "quarter": "Q4",
      "lane": "TEAM",
      "description": "A standardization effort to converge on preferred IDEs, libraries, linting rules and project templates. It reduces fragmentation, simplifies onboarding and enables shared tooling like CI, QA and telemetry to work consistently across teams.\n",
      "branchOnly": true,
      "parent": "TECH-COURSE"
    },
    {
      "id": "TECH-STACK",
      "level": "goal",
      "title": "Tech stack Selection for AI Acceleration - From Novice to Expert",
      "year": 2022,
      "quarter": "Q4",
      "month": 8,
      "week": 3,
      "lane": "TEAM",
      "description": "A curated tech stack that balances full-stack delivery needs with AI acceleration capabilities. It aligns skills, tools and patterns so the team can grow from novice experiments to production-grade AI solutions.\n",
      "branchOnly": false,
      "parent": "TECH-GAPS",
      "fanOut": false,
      "image": "D&AS-Accelerated-Stack-FY26.svg"
    },
    {
      "id": "OPNAI",
      "week": 1,
      "month": 9,
      "level": "achievement",
      "title": "Open AI GPT - Boom: GPT-3.5",
      "year": 2022,
      "quarter": "Q4",
      "lane": "VISION",
      "description": "Recognition of GPT-3.5 as an inflection point for natural language understanding and generation in enterprise workflows. This milestone anchors subsequent experiments in chatbots, summarization and agent-assist capabilities across clients.\n",
      "branchOnly": false
    },
    {
      "id": "KICK-OFF",
      "week": 2,
      "month": 9,
      "level": "goal",
      "title": "R&D Kick Off - Strategic Planning",
      "year": 2022,
      "quarter": "Q4",
      "lane": "VISION",
      "description": "A formal kickoff to define R&D focus areas, success metrics and alignment with business priorities. It sets expectations on experimentation, knowledge sharing and how POCs will convert into production use cases.\n",
      "branchOnly": false,
      "image": "technical-competencies.png"
    },
    {
      "id": "CAMS",
      "level": "goal",
      "title": "CAMS Expert Utilization and Commercial Mandate",
      "year": 2022,
      "quarter": "Q4",
      "month": 9,
      "week": 2,
      "lane": "VISION",
      "description": "A mandate for all leaders to  perform GCC Farming utilizing CAMS capailities into tangible commercial offerings for clients \n",
      "branchOnly": false
    },
    {
      "id": "PPA-NORMET-W",
      "level": "subitem",
      "title": "Normet Warehouse",
      "year": 2023,
      "quarter": "Q1",
      "month": 10,
      "week": 2,
      "lane": "COMMERCIAL",
      "description": "Warehouse-oriented structuring of Normet information and processes to support automation and reporting. It lays the groundwork for inventory-like visibility into documents, tickets and operational assets.\n",
      "branchOnly": true,
      "parent": "CAMS"
    },
    {
      "id": "PPA-NORMET-PS",
      "level": "subitem",
      "title": "Normet Packing Structure",
      "year": 2023,
      "quarter": "Q1",
      "month": 10,
      "week": 4,
      "levelLane": 2,
      "lane": "COMMERCIAL",
      "description": "Design of a standardized packing structure for Normet-related documents and artifacts. This supports cleaner data classification, easier retrieval and downstream automation on top of SharePoint and related systems.\n",
      "branchOnly": true,
      "parent": "CAMS"
    },
    {
      "id": "TECH",
      "level": "goal",
      "title": "Heart of Programming - Fundamental First Principles of a Modern Engineer",
      "year": 2023,
      "quarter": "Q1",
      "month": 10,
      "week": 1,
      "lane": "TEAM",
      "description": "A foundational learning stream covering modern programming mindset, problem decomposition, and core language constructs. It sets the baseline for all D&AS engineers before they specialize into AI, data, or automation tracks.\n",
      "branchOnly": false,
      "parent": "KICK-OFF"
    },
    {
      "id": "POCPORT",
      "level": "goal",
      "title": "RAMP-UP AI Portfolio - POC First Approach",
      "year": 2023,
      "quarter": "Q1",
      "month": 10,
      "week": 4,
      "lane": "PROCESS",
      "description": "Organzation wide to ramp-up AI adoption due to heightened hype post GPT-3.5 release.\n",
      "branchOnly": false,
      "parent": "FY23LC"
    },
    {
      "id": "AID",
      "level": "subitem",
      "title": "App in Day - Hackcelerate",
      "year": 2023,
      "quarter": "Q1",
      "month": 11,
      "week": 1,
      "lane": "TEAM",
      "description": "A rapid “App in a Day” style hackcelerator that walks members through building real apps on Power Platform from scratch. It accelerates hands-on learning and produces early prototypes that can be hardened into production use cases.\n",
      "branchOnly": true,
      "parent": "PP"
    },
    {
      "id": "ENV-PP",
      "level": "subitem",
      "title": "PP Environments – Governance and Access",
      "year": 2023,
      "quarter": "Q1",
      "month": 11,
      "week": 3,
      "lane": "TEAM",
      "description": "Setup and governance of dedicated Dev Power Platform environments for experimentation, Utlizing Microsoft Developer Program freebies.\n",
      "branchOnly": true,
      "parent": "AID"
    },
    {
      "id": "ENV-AZ",
      "level": "goal",
      "title": "Azure Cloud - Resolving the Gap of D&AS Primary Weakness",
      "year": 2023,
      "quarter": "Q1",
      "month": 11,
      "week": 2,
      "lane": "TEAM",
      "description": "Establishment of Azure landing zones and subscriptions by utlizing Visual Studio License Benefits for free creadits,  this ensures the team can perform foundational ai integration, analytics and automation workloads.  Preparing them for future scale and improving the biggest gaps in the Team's Capabilities\n",
      "branchOnly": false,
      "parent": "ENV-PP, KICK-OFF"
    },
    {
      "id": "PP",
      "level": "goal",
      "title": "D&AS additional offerings: PowerPlatform Customization",
      "year": 2023,
      "quarter": "Q1",
      "month": 11,
      "week": 4,
      "lane": "PROCESS",
      "description": "A stream of work focused on building reusable Power Platform extensions, custom components and connectors that plug into client and internal workflows. It creates a governed way to extend low-code solutions while still meeting enterprise standards on security and support.\n",
      "branchOnly": true,
      "parent": "PPA-NORMET-PS, PPA-NORMET-W"
    },
    {
      "id": "INTERNS-AI-5",
      "level": "subitem",
      "title": "AI Interns Started Batch 5",
      "year": 2023,
      "quarter": "Q2",
      "month": 2,
      "week": 3,
      "lane": "TEAM",
      "description": "Leverage the current internship program for fullstack and automation to onboard the fifth batch of interns with the shift in focus to AI.  Current interns that joined the program did not yet meet the bar for AI delivery work. The outcome emphasized shows the need of the expert to directly be involved in the screening specially on AI technical readiness criterias.\n",
      "branchOnly": true,
      "parent": "POCPORT",
      "image": "intern-batch-5.png"
    },
    {
      "id": "EPOS",
      "level": "subitem",
      "title": "EPOS for Germany – Proof of Concept",
      "year": 2023,
      "quarter": "Q2",
      "month": 1,
      "week": 1,
      "lane": "INTERNAL",
      "description": "The initial EPOS proof of concept focused on German employee data and document structures. It validates the classification, privacy controls and migration patterns before scaling to later phases like bulk upload, dashboarding and additional countries.Q\n",
      "branchOnly": false,
      "parent": "POCPORT"
    },
    {
      "id": "HYBDRID",
      "level": "goal",
      "title": "Hybrid Arcitecture",
      "year": 2023,
      "month": 7,
      "week": 1,
      "quarter": "Q3",
      "lane": "INTERNAL",
      "branchOnly": false,
      "description": "Exploration of a hybrid on-prem and cloud architecture to balance security, latency and scalability requirements. The goal is to design patterns that allow sensitive workloads to stay controlled while leveraging cloud elasticity for AI and analytics.\n",
      "parent": "TECH-GAPS"
    },
    {
      "id": "EWI-CL",
      "level": "subitem",
      "title": "EWI Classifier and Attrition Predictors",
      "year": 2023,
      "quarter": "Q3",
      "month": 5,
      "week": 2,
      "lane": "RND",
      "description": "R&D work on classifying early warning indicators and predicting attrition using internal data. The goal is to support proactive workforce planning and targeted retention interventions.\n",
      "branchOnly": true,
      "parent": "FORESIGHT"
    },
    {
      "id": "VECT-IR",
      "level": "goal",
      "title": "Billion Vector Based Information Retrieval",
      "year": 2023,
      "quarter": "Q1",
      "month": 12,
      "week": 3,
      "lane": "RND",
      "description": "Exploration of dense vector search at billion-scale to move beyond keyword-based retrieval. This capability underpins more relevant semantic search and recommendation experiences in enterprise contexts.\n",
      "branchOnly": true
    },
    {
      "id": "CX-ITSM-TXCL",
      "level": "subitem",
      "title": "CX ITSM Virtual Agent",
      "year": 2023,
      "quarter": "Q2",
      "month": 3,
      "week": 1,
      "lane": "internal",
      "description": "Development of a virtual agent for ITSM that can triage, respond and assist on tickets across channels. It combines conversational AI with ticketing data to reduce handle time and improve end-user experience.\n",
      "branchOnly": true,
      "parent": "SMTX"
    },
    {
      "id": "AIW",
      "level": "goal",
      "title": "AI Workshop - Session 1 & 2 (EUSS, CBPS, CAMS)",
      "year": 2023,
      "quarter": "Q2",
      "month": 2,
      "week": 1,
      "lane": "PROCESS",
      "description": "Foundational AI workshops delivered to EUSS, CBPS and CAMS to build a shared understanding of capabilities and use cases. The sessions seed a pipeline of ideas and prepare stakeholders to engage meaningfully in automation initiatives.\n",
      "branchOnly": false
    },
    {
      "id": "VECT-EMB",
      "level": "subitem",
      "title": "Jina Embbeding + FAISS",
      "year": 2023,
      "quarter": "Q2",
      "month": 5,
      "week": 2,
      "lane": "RND",
      "description": "Experimentation with Jina embeddings and FAISS as a vector search backbone. This helps validate latency, accuracy and deployment patterns for large-scale semantic search solutions.\n",
      "branchOnly": true,
      "parent": "VECT-IR"
    },
    {
      "id": "FORESIGHT",
      "level": "subitem",
      "title": "Foresight Virtual Agent - V2",
      "year": 2023,
      "quarter": "Q2",
      "month": 5,
      "week": 4,
      "lane": "RND",
      "description": "The second iteration of the Foresight virtual agent with deeper analytics, prediction and virtual assistance features. It moves from basic reporting to proactive insights and recommendations for operations teams.\n",
      "branchOnly": false
    },
    {
      "id": "ITSM-GENVA",
      "level": "subitem",
      "title": "ITSM - Teams Generative Virtual Agent",
      "year": 2023,
      "quarter": "Q3",
      "month": 6,
      "week": 1,
      "lane": "RND",
      "description": "A generative AI-powered virtual agent embedded in Teams to assist with ITSM-related tasks and inquiries. It reduces friction for end users and exemplifies Microsoft ecosystem integration patterns for future solutions.\n",
      "branchOnly": true,
      "parent": "CX-ITSM-TXCL, OPNAI"
    },
    {
      "id": "FY23RETRO",
      "level": "goal",
      "title": "FY23 Retrosepctive",
      "year": 2024,
      "quarter": "Q1",
      "month": 10,
      "week": 1,
      "lane": "VISION",
      "description": "A year-end retrospective reviewing wins, misses and learnings from FY23 automation and AI initiatives. It consolidates best practices and anti-patterns that feed into strategic planning for the next fiscal year.\n",
      "branchOnly": false,
      "fanOut": false,
      "quarterCenter": false,
      "parent": "AIW3"
    },
    {
      "id": "FY24LC",
      "level": "goal",
      "title": "FY24 Leadership Connect: Delivering Compeling Solution",
      "year": 2024,
      "month": 10,
      "week": 1,
      "quarter": "Q1",
      "lane": "VISION",
      "description": "Leadership engagement focused on showcasing compelling end-to-end automation and AI solutions delivered in FY24. It reinforces the narrative of moving from isolated POCs to integrated, outcome-focused capabilities for clients and internal units.\n",
      "branchOnly": false,
      "fanOut": false,
      "quarterCenter": false,
      "parent": "FY23RETRO"
    },
    {
      "id": "2024-Q2-visitor-log",
      "level": "subitem",
      "title": "Visitor Log",
      "year": 2024,
      "quarter": "Q1",
      "month": 1,
      "week": 1,
      "lane": "INTERNAL",
      "description": "A web-based visitor log application that digitizes entry tracking and integrates with forecasting and analytics. It replaces manual logging processes, improves data quality and supports reporting on site utilization.\n",
      "branchOnly": true,
      "parent": "INTERNS-AI-6"
    },
    {
      "id": "L-LLM",
      "week": 1,
      "month": 5,
      "level": "goal",
      "title": "Localized Large Language Model",
      "year": 2023,
      "quarter": "Q2",
      "lane": "RND",
      "description": "R&D work on tailoring large language models to local languages and domain-specific vocabulary. The goal is to improve accuracy, cultural fit and trust for internal and client-facing AI assistants.\n",
      "branchOnly": false,
      "parent": "VECT-EMB"
    },
    {
      "id": "GHRMS-TXCL",
      "level": "subitem",
      "title": "GHRMS Ticket Classification",
      "year": 2023,
      "quarter": "Q3",
      "month": 6,
      "week": 2,
      "lane": "INTERNAL",
      "description": "Automation that classifies GHRMS tickets to improve routing, reporting and workload management. It supports service teams by reducing manual categorization effort and improving SLA adherence.\n",
      "branchOnly": true,
      "parent": "CX-ITSM-TXCL"
    },
    {
      "id": "INTERNS",
      "level": "goal",
      "title": "Internship to Hire - Grading and Deliverables",
      "year": 2023,
      "month": 8,
      "week": 2,
      "quarter": "Q4",
      "lane": "VISION",
      "description": "A structured framework for evaluating interns through graded deliverables and clear expectations. It helps identify high-potential candidates who can transition into junior roles within D&AS.\n",
      "branchOnly": false,
      "parent": "INTERNS-AI-5",
      "image": "internship-to-hire-fy24.png"
    },
    {
      "id": "INTERNS-AI-6",
      "week": 1,
      "month": 9,
      "level": "goal",
      "title": "AI Interns Started Batch 6",
      "year": 2023,
      "quarter": "Q4",
      "lane": "TEAM",
      "description": "The sixth batch of AI interns is onboarded with closer involvement from core team members in screening and mentoring. The iteration refines the internship-to-hire pipeline to better align intern output with production AI needs. results with 50% hire rate.\n",
      "branchOnly": false,
      "image": "internship-to-hire-FY25.png",
      "parent": "INTERNS, INTERNS-AI-5"
    },
    {
      "id": "SST-TTS",
      "week": 1,
      "month": 5,
      "level": "goal",
      "title": "Speech Recognition and Synthesis",
      "year": 2023,
      "quarter": "Q3",
      "lane": "RND",
      "description": "Foundational R&D on automatic speech recognition and text-to-speech models for meetings, calls and virtual agents. These capabilities underpin multilingual bots, live transcription and accessibility features in later solutions. ✅  1. ASR - Text to Speech Model ✅  2. Speech Translation Model ✅  3. Voice Synthesis Model\n",
      "branchOnly": false,
      "parent": "AIW3"
    },
    {
      "id": "NNT",
      "week": 1,
      "month": 6,
      "level": "goal",
      "title": "Neural Machine Translation",
      "year": 2023,
      "quarter": "Q3",
      "lane": "RND",
      "description": "Exploration of neural machine translation models to support multilingual operations and content. It lays the groundwork for translation features in ServiceNow, Teams and browser-based tools.\n",
      "branchOnly": false,
      "parent": "SST-TTS"
    },
    {
      "id": "2024-Q2-itsm-predictive-analytics-localized-model",
      "level": "subitem",
      "title": "ITSM - Predictive Analytics - Localized Model",
      "year": 2023,
      "quarter": "Q4",
      "lane": "INTERNAL",
      "description": "Localized predictive models applied to ITSM data to forecast volume, risk or SLA breaches. These insights feed into planning, staffing and proactive issue management.\n",
      "branchOnly": true,
      "parent": "INTERNS-AI-6"
    },
    {
      "id": "2024-Q2-sentiment-analysis-localized-model-infeedo-like",
      "level": "subitem",
      "title": "Sentiment Analysis - Localized Model - Infeedo Like",
      "year": 2023,
      "quarter": "Q4",
      "lane": "RND",
      "description": "Development of localized sentiment models inspired by platforms like Infeedo to understand employee feedback. The aim is to power engagement analytics and early detection of morale issues.\n",
      "branchOnly": true,
      "parent": "INTERNS-AI-6"
    },
    {
      "id": "2024-Q2-localized-custom-token-classification",
      "level": "subitem",
      "title": "Localized Custom Token Classification",
      "year": 2023,
      "quarter": "Q4",
      "lane": "RND",
      "description": "Experiments in custom token classification for local languages and domain vocabularies. It improves entity recognition for downstream models in HR, ITSM and customer support.\n",
      "branchOnly": true,
      "parent": "INTERNS-AI-6"
    },
    {
      "id": "EPOS-DE",
      "week": 2,
      "level": "goal",
      "title": "EPOS Document Intelligence - Phase 1-4",
      "year": 2023,
      "quarter": "Q2",
      "month": 3,
      "lane": "COMMERCIAL",
      "description": "Initial phases of EPOS work focusing on correctly classifying document owners, standardizing naming and organizing content. These foundations reduce privacy risk and enable automated file migration and reporting for the client.\n✅ 1. Classifying document owners ✅ 2. Standardizing naming ✅ 3. Organizing content ✅ 4. EPOS SP Migration - Phase 4 EPOS SharePoint migration focusing on scaling and hardening the automated file movement process. It continues to reduce manual effort while maintaining privacy and compliance controls.\n",
      "parent": "EPOS",
      "branchOnly": false
    },
    {
      "id": "AIW3",
      "week": 1,
      "month": 4,
      "level": "goal",
      "title": "AI Workshop: Algorithmic Mindeset. Session 3 - Valmett 17 HC",
      "year": 2023,
      "quarter": "Q2",
      "lane": "PROCESS",
      "description": "A focused workshop on algorithmic thinking delivered to a Valmet cohort. It reinforces how to frame problems for AI, read model outputs and collaborate effectively with automation teams.\n",
      "branchOnly": false,
      "parent": "AIW",
      "image": "fy24-ai-worshop.png"
    },
    {
      "id": "PCF-EMB-SWC",
      "week": 1,
      "month": 1,
      "level": "goal",
      "title": "PowerApps Component Framework",
      "year": 2023,
      "quarter": "Q2",
      "lane": "RND",
      "description": "Proof of concept for embedding nalytics into PCF components for SWECON-related scenarios with predictive capabilities. It demonstrates how to surface insights directly within operational workflows instead of separate reports.\n",
      "branchOnly": false
    },
    {
      "id": "OBSERVABLE",
      "level": "goal",
      "title": "Telemetry: Road to Observability",
      "year": 2024,
      "quarter": "Q2",
      "month": 3,
      "week": 2,
      "lane": "VISION",
      "description": "A vision to evolve basic telemetry into full observability using multi-node command center infrastructure. It emphasizes proactive detection of bottlenecks, workflow patterns and performance issues across systems.\n# Frankies Box of Fun Things Series\n",
      "branchOnly": false,
      "parent": "FY23RETRO"
    },
    {
      "id": "BREXT",
      "week": 1,
      "month": 3,
      "level": "goal",
      "title": "Box of Fun things: Browser Extension Automation",
      "year": 2024,
      "quarter": "Q2",
      "lane": "Team",
      "description": "Foundational work on a browser extension framework to automate repetitive web-based tasks. This becomes the base for later tools like PSA time entry helpers and KB search extensions.\n# Frankies Box of Fun Things Series\n",
      "branchOnly": true,
      "parent": "OBSERVABLE"
    },
    {
      "id": "PT-MINER",
      "week": 1,
      "month": 3,
      "level": "goal",
      "title": "Box of Fun things: Process & Task Mining",
      "year": 2024,
      "quarter": "Q2",
      "lane": "RND",
      "description": "Exploration of process and task mining techniques over telemetry and operational data. The goal is to identify hidden bottlenecks, rework loops and automation opportunities at scale.\n# Frankies Box of Fun Things Series\n",
      "branchOnly": true,
      "parent": "OBSERVABLE"
    },
    {
      "id": "VVA-GCA",
      "week": 2,
      "month": 7,
      "level": "subitem",
      "title": "Voice Virtual Agent - Google Conversational AI",
      "year": 2023,
      "quarter": "Q2",
      "lane": "INTERNAL",
      "description": "A voice-enabled virtual agent powered by Google Conversational AI for handling multilingual, speech-based interactions.\n",
      "branchOnly": true,
      "parent": "SST-TTS"
    },
    {
      "id": "2024-Q3-image-to-3d",
      "level": "subitem",
      "title": "Image to 3D",
      "year": 2024,
      "quarter": "Q3",
      "lane": "RND",
      "description": "Experimental work on converting 2D images into 3D representations. The capability could enable virtual tours, visualization tools or enhanced digital twins in future projects.\n",
      "branchOnly": true,
      "parent": "INTERNS-AI-6"
    },
    {
      "id": "FIBA",
      "week": 3,
      "month": 4,
      "level": "goal",
      "title": "FIBA - Real-Time Speech Enabled Multilingial Avatar",
      "year": 2024,
      "quarter": "Q2",
      "lane": "COMMERCIAL",
      "description": "Initial phase combining migration work with real-time audio input/output and avatar capabilities for a client scenario. It pilots how generative AI, speech and visual components can come together in live interactions.\n",
      "branchOnly": false,
      "parent": "VVA-GCA"
    },
    {
      "id": "FI-CTRL",
      "level": "goal",
      "title": "FI Finance - GL & DelRev Automation",
      "year": 2024,
      "month": 1,
      "week": 3,
      "laneLeve": 1,
      "quarter": "Q2",
      "lane": "COMMERCIAL",
      "description": "Automation of FI Controllership processes around general ledger and deferred revenue. The solution reduces manual reconciliation, accelerates reporting and strengthens financial controls.\n",
      "branchOnly": false,
      "fanOut": false,
      "quarterCenter": false
    },
    {
      "id": "PROPERPAY1",
      "week": 3,
      "month": 11,
      "level": "goal",
      "title": "Properpay Phase 1 - RES Audit Letter Creation",
      "year": 2024,
      "quarter": "Q1",
      "lane": "INTERNAL",
      "description": "The first phase of ProperPay ICU letter creation delivering smart, self-filling templates for audit-related letters. It drastically cuts preparation time and standardizes content, enabling more audits per nurse per day.\n",
      "branchOnly": false
    },
    {
      "id": "SAGA-PCF",
      "level": "goal",
      "title": "SAGA: PCF - PBI Embedded Analytics",
      "year": 2024,
      "quarter": "Q2",
      "month": 1,
      "week": 1,
      "laneLevel": 2,
      "lane": "COMMERCIAL",
      "description": "Work on embedding Power BI analytics into SAGA PCF components. It demonstrates how operational users can see key metrics directly within transaction flows.\n",
      "branchOnly": false,
      "parent": "PCF-EMB-SWC"
    },
    {
      "id": "LL-LLLM",
      "week": 4,
      "month": 3,
      "level": "goal",
      "title": "Localized Lightweight Large Language Model (LL-LLM)",
      "year": 2024,
      "quarter": "Q2",
      "lane": "COMMERCIAL",
      "description": "Investigation into smaller, localized LLMs suitable for constrained environments and specific languages. This supports clients who need AI capabilities without relying solely on large external models.\n",
      "branchOnly": false,
      "parent": "LLLM"
    },
    {
      "id": "PROPERPAY2",
      "level": "subitem",
      "title": "Phase 2 - Additional Forms and Templates",
      "year": 2024,
      "quarter": "Q2",
      "lane": "INTERNAL",
      "month": 3,
      "week": 1,
      "description": "Expansion of the ProperPay ICU letter creation tool to support more forms and templates. This further reduces manual drafting time and standardizes outputs across more case types.\n",
      "branchOnly": true,
      "parent": "PROPERPAY1"
    },
    {
      "id": "VMET-AI",
      "level": "goal",
      "title": "Valmet Service Now Limitation Usecases",
      "year": 2024,
      "quarter": "Q1",
      "month": 10,
      "week": 3,
      "lane": "COMMERCIAL",
      "description": "A catalog of AI and automation use cases that work within Valmet’s ServiceNow constraints. It aligns expectations and guides prioritization for predictive intelligence, translation and agent assist features. ❌ 1. Valmet HappySignals - Sentiment Analysis ✅ 2. Valmet Problem candidate identification  ✅ 3. Valmet Predicting incident ticket that are possible major incident candidates ✅ 4. Valmet Predicting incident Security Incident ❌ 5. Valmet HappySignals trend per agent ❌ 6. Valmet HappySignals analysis with Ticket number and agent ❌ 7. Valmet PI for Spotlight IT team - Quality Incidents, Safety Incidents\n",
      "branchOnly": false,
      "parent": "SMTX-TXCL"
    },
    {
      "id": "BMO",
      "level": "goal",
      "title": "BMO Discovery AI and Automation Usecases",
      "year": 2025,
      "quarter": "Q1",
      "month": 11,
      "week": 4,
      "lane": "COMMERCIAL",
      "description": "Discovery work with BMO to map out AI and automation opportunities across QA, coaching, disputes and operations. It seeds multiple initiatives around ticket analytics, predictive intelligence and quality automation.\n❌ 1. BMO Carbon Assets Canvas Apps - Canvas apps designed to track and analyze carbon-related assets. They provide a more intuitive interface for managing environmental metrics and reporting. ❌ 2. BMO Finance Emissions - A use case focusing on finance-related emissions data and calculations. It supports the bank's broader ESG and sustainability reporting obligations. ❌ 3. BMO Remote Deposit - A remote deposit-related automation or application for BMO. It targets operational efficiency in how deposit-related tasks are processed and tracked. ❌ 4. BMO Help Desk - A catalogue of potential automation and AI use cases for BMO's help desk function. It guides future investments in agent assist, predictive routing and self-service capabilities. ❌ 5. BMO BID Smart Ticketing - A smart ticketing initiative for BMO's operations. It focuses on improving classification, routing and reporting to reduce effort and delays. ✅ 6. BMO Audit, Coaching and Dispute - Design of a centralized QA platform for BMO audits, coaching and disputes. It aims to shorten audit cycles, increase transparency and provide richer performance insights.\n",
      "branchOnly": false,
      "fanOut": false,
      "quarterCenter": false
    },
    {
      "id": "VMET-AUT-FACTORY",
      "level": "goal",
      "title": "Valmet Automation Factory",
      "year": 2024,
      "quarter": "Q2",
      "month": 1,
      "week": 3,
      "lane": "COMMERCIAL",
      "description": "❌ 1. Valmet Summary Generation, Generative API connection ✅ 2. Valmet Allow translation for chat(once available) ❌ 3. Valmet Allow translation for voice(once available) ❌ 4. Valmet Knowledge Base Translation ✅ 5. Swedish translation ✅ 6. Valmet ServiceNow KB Conversational VA with- Swedish translation ✅ 7. Enhancement of Prod Teams Virtual Agent\n",
      "branchOnly": false,
      "parent": "VMET-AI"
    },
    {
      "id": "AI-ENG",
      "level": "goal",
      "title": "Accelerate succession path for AI Engineering",
      "year": 2024,
      "quarter": "Q4",
      "month": 7,
      "week": 3,
      "lane": "TEAM",
      "description": "A structured allocation that requires a collaboration of 1 AI develooper  and 1 integration engineer performing AI engineering tasks due to the lack of resource and  expertise in the market. Both roles will work closely to deliver AI solutions to clients  while learning from each other and building of each other the AI engineer capabilities they lack.\n",
      "branchOnly": false,
      "image": "AI-engineering-path.png",
      "parent": "AI-INT, FY24RETRO"
    },
    {
      "id": "EPOS-UP",
      "level": "subitem",
      "title": "Bulk Upload",
      "year": 2024,
      "quarter": "Q4",
      "month": 6,
      "week": 4,
      "lane": "COMMERCIAL",
      "description": "✅ 1. Extension of EPOS to support bulk upload of documents and metadata. ✅ 2. It simplifies onboarding of large data sets and reinforces standardized classification.  ✅ 3. Upload to PSA ⬜ 4. EPOS for NL (once Germany is Completed) ⬜ 5. EPOS for Finland ⬜ 6. EPOS-GBS\n",
      "branchOnly": true,
      "parent": "EPOS-DE"
    },
    {
      "id": "SANDVIK-TPPA",
      "week": 1,
      "month": 7,
      "level": "goal",
      "title": "SANDVIK: Teams and Power Platform Assessment",
      "year": 2024,
      "quarter": "Q4",
      "lane": "COMMERCIAL",
      "description": "Advisory work with Sandvik’s Cybersecurity Board on Teams integrations, Graph permissions and elevated scopes. The engagement balances enabling automation with strict security governance across tools and tenants.\n",
      "branchOnly": true,
      "parent": "ITSM-GENVA",
      "image": "sandvik-teams.png"
    },
    {
      "id": "LLM-INSTRUCT",
      "week": 1,
      "month": 7,
      "level": "goal",
      "title": "LLM Instruct Mode: NLP Downstream tasks",
      "year": 2024,
      "quarter": "Q4",
      "lane": "RND",
      "description": "R&D on using instruct-tuned LLMs for downstream NLP tasks like classification, summarization and extraction. It tests how far generic models can be steered with prompts before custom fine-tuning is needed.\n",
      "branchOnly": false,
      "parent": "LL-LLLM"
    },
    {
      "id": "AI-ROLE",
      "level": "goal",
      "title": "Role Specialization",
      "year": 2024,
      "quarter": "Q2",
      "month": 2,
      "week": 3,
      "lane": "TEAM",
      "description": "A framework that clarifies the roles, responsibilities and artefacts across AI initiatives – from product owners and solution architects to BAs, ML Developers, Data Scientists and AI Engineers. Which also includes integration engineer, devops engineer and MLOps engineer roles to support end-to-end delivery.\n",
      "branchOnly": false,
      "image": "specialized-role.png",
      "parent": "FY23RETRO"
    },
    {
      "id": "AI-INT",
      "level": "goal",
      "title": "Integration Team Foundation",
      "year": 2024,
      "quarter": "Q3",
      "month": 5,
      "week": 2,
      "lane": "TEAM",
      "description": "A dedicated integration team that bridges AI models with existing systems, data sources and workflows. This function ensures seamless connectivity, data flow and orchestration across diverse enterprise environments. A complement on the AI development team to deliver end-to-end solutions by leveraging enterprise open systems architecture.\n",
      "branchOnly": false,
      "image": "Integration-team.png",
      "parent": "AI-ROLE"
    },
    {
      "id": "MULTI-NODE-COMPUTE",
      "level": "goal",
      "title": "D&AS R&D Multi-Node GPU Environment",
      "year": 2024,
      "quarter": "Q3",
      "month": 6,
      "week": 1,
      "lane": "RND",
      "branchOnly": false,
      "description": "Leveraging GPU enabled T4 Servers for a Multi-Node Resource Extensive Compute AI Development Environment - Distributed Multi-Node Compute, Observability Command Center, Data Engineering.\n",
      "parent": "OBSERVABLE, HYBDRID"
    },
    {
      "id": "PI-VMET-PROB",
      "week": 4,
      "month": 7,
      "level": "subitem",
      "title": "Valmet Problem candidate identification",
      "year": 2024,
      "quarter": "Q4",
      "lane": "COMMERCIAL",
      "description": "Machine learning models that flag tickets likely to evolve into problem records. This supports proactive problem management and reduces repeat incidents for Valmet.\n",
      "branchOnly": true,
      "parent": "VMET-AUT-FACTORY",
      "image": "valmet-problem-prediction.png"
    },
    {
      "id": "PI-VMET-MI",
      "week": 4,
      "month": 7,
      "level": "subitem",
      "title": "Valmet Predicting incident ticket that are possible major incident candidates",
      "year": 2024,
      "quarter": "Q4",
      "lane": "COMMERCIAL",
      "description": "Predictive models that detect which new incidents may become major incidents. They trigger early notifications so incident managers can respond before impact escalates.\n",
      "branchOnly": true,
      "parent": "VMET-AUT-FACTORY",
      "image": "valmet-major-incident.png"
    },
    {
      "id": "BMO-AUDIT",
      "week": 4,
      "month": 7,
      "level": "subitem",
      "title": "BMO TPS Audit, Coaching and Dispute",
      "year": 2024,
      "quarter": "Q4",
      "lane": "COMMERCIAL",
      "description": "Design of a centralized QA platform for BMO TPS audits, coaching and disputes. It aims to shorten audit cycles, increase transparency and provide richer performance insights.\n",
      "branchOnly": true,
      "parent": "BMO",
      "image": "qa-for-bmo.png"
    },
    {
      "id": "KB-BOT",
      "level": "goal",
      "title": "Foresters - KnowIT KB Bot Crawler",
      "year": 2024,
      "quarter": "Q1",
      "month": 12,
      "week": 3,
      "lane": "COMMERCIAL",
      "description": "A crawler-powered KB bot for Foresters that indexes and surfaces knowledge articles to agents. It reduces search time and supports faster, more consistent ticket resolution.\n❌ 1. Authentication On-Behalf-Of FLow ✅ 2. KB Bot Crawler Integration\n",
      "fanOut": false,
      "quarterCenter": false,
      "branchOnly": false
    },
    {
      "id": "TELEMETRY",
      "level": "goal",
      "title": "Telemetry - PILOT (SSAB)",
      "year": 2024,
      "quarter": "Q4",
      "month": 8,
      "week": 4,
      "laneLeve": 2,
      "lane": "COMMERCIAL",
      "description": "Pilot deployment of telemetry collectors for SSAB to capture device and workflow signals. It is a precursor to full observability and the CGI Scryer command center vision.\n",
      "branchOnly": false,
      "parent": "OBSERVABLE"
    },
    {
      "id": "FY24RETRO",
      "level": "goal",
      "title": "FY24 Retrosepctive",
      "year": 2024,
      "quarter": "Q4",
      "month": 9,
      "week": 1,
      "lane": "VISION",
      "description": "A strategic retrospective covering FY24’s automation, AI and commercial outcomes. It consolidates metrics, case studies and lessons to steer FY25 planning and Leadership Connect themes.\n",
      "branchOnly": false
    },
    {
      "id": "FY25LC",
      "level": "goal",
      "title": "FY25 Leadership Connect: ?????",
      "year": 2024,
      "quarter": "Q4",
      "month": 9,
      "week": 2,
      "lane": "VISION",
      "description": "Placeholder for the FY25 Leadership Connect theme, intended to build on prior years’ strategic narratives. The session will likely highlight new flagship use cases, financial impact and roadmap pivots.\n",
      "branchOnly": false
    },
    {
      "id": "2024-Q1-ai-automation-for-hr-nte",
      "level": "goal",
      "title": "AI/Automation for HR NTE",
      "year": 2025,
      "quarter": "Q1",
      "month": 12,
      "week": 2,
      "lane": "INTERNAL",
      "description": "A broader initiative to apply AI and automation within HR NTE processes. It looks at repetitive tasks, document flows and decision points that can benefit from intelligent tooling.\n",
      "branchOnly": false,
      "fanOut": false,
      "quarterCenter": false
    },
    {
      "id": "AUDITOOL",
      "level": "subitem",
      "title": "BMO TPS QA Audit - Agentic - Teams Embedded POC",
      "year": 2025,
      "quarter": "Q1",
      "month": 10,
      "week": 1,
      "lane": "RND",
      "description": "A proof of concept for an agentic QA audit tool embedded inside Teams for BMO TPS. It showcases how LLMs can prefill forms, suggest coaching points and streamline audit workflows.\n",
      "branchOnly": true,
      "parent": "BMO-AUDIT, LLM-INSTRUCT",
      "image": "qa-for-bmo.png"
    },
    {
      "id": "CIFIN",
      "level": "goal",
      "title": "CI FIN Re-Discovery",
      "year": 2025,
      "quarter": "Q1",
      "month": 11,
      "week": 1,
      "lane": "COMMERCIAL",
      "description": "Re-discovery engagement with CI Financial to revisit automation opportunities and constraints. It explores how newer tools like browser extensions, QA platforms and scorecards can extend earlier work.\n❌ 1. CI FIN - Audit Form - Standardizes CI Financial QA audits using generic QA platform patterns to ensure consistent audit capture and improved trend analysis. ✅ 2. CI Macro Extraction - Modernizes legacy Selenium-based macros for CI workflows to deliver an approved, supportable automation stack using updated Selenium and Python.\n",
      "branchOnly": false
    },
    {
      "id": "PI-VMET-SEC",
      "level": "subitem",
      "title": "Predicting Security Incident",
      "year": 2024,
      "quarter": "Q3",
      "month": 6,
      "week": 1,
      "lane": "COMMERCIAL",
      "description": "Machine learning models that flag potential security incidents in Valmet’s ticket stream. They complement problem and major-incident predictors to strengthen overall risk posture.\n",
      "branchOnly": false,
      "parent": "VMET-AUT-FACTORY",
      "image": "valmet-security.png"
    },
    {
      "id": "AWSAZAI",
      "level": "subitem",
      "title": "AZ-Speech AWS Connect - Azure Speech",
      "year": 2025,
      "quarter": "Q1",
      "month": 12,
      "week": 1,
      "lane": "INTERNAL",
      "description": "Integration of Azure Speech services with AWS Connect to build multilingual, speech-enabled bots. It demonstrates cross-cloud interoperability and informs future voice agent architectures.\n",
      "branchOnly": true,
      "parent": "FIBA"
    },
    {
      "id": "KNOWIT-AA",
      "level": "subitem",
      "title": "KnowIT: Agent Assist Extension",
      "year": 2025,
      "quarter": "Q2",
      "week": 1,
      "month": 1,
      "lane": "RND",
      "description": "An agent-assist extension for KnowIT that surfaces KB context and suggestions directly in the workflow. It reduces context switching for agents and increases reuse of validated resolutions.\n",
      "branchOnly": true,
      "parent": "BREXT, KB-BOT"
    },
    {
      "id": "WFM",
      "level": "goal",
      "title": "WFM: Harmonization",
      "year": 2025,
      "quarter": "Q2",
      "month": 1,
      "week": 4,
      "lane": "internal",
      "description": "Harmonization of workforce management tooling with LogIT and similar systems. The goal is a consistent, data-driven view of staffing, attendance and forecasting across engagements.\n",
      "branchOnly": true,
      "fanOut": false,
      "quarterCenter": false,
      "parent": "2024-Q1-ai-automation-for-hr-nte"
    },
    {
      "id": "PI-VMET",
      "level": "goal",
      "title": "Predictive Intelligence API: CSI (Incidents)",
      "year": 2025,
      "quarter": "Q2",
      "month": 2,
      "week": 1,
      "lane": "COMMERCIAL",
      "description": "Exposure of Valmet predictive intelligence models as APIs for consumption by CSI and incident workflows. It standardizes how predictions are integrated and monitored across multiple consumers.\n",
      "branchOnly": true,
      "parent": "PI-VMET-SEC"
    },
    {
      "id": "SANDVIK-IA",
      "level": "goal",
      "title": "Sandvik - Integration Assessment - Elevated Integration Scopes",
      "year": 2025,
      "quarter": "Q2",
      "week": 1,
      "month": 3,
      "lane": "COMMERCIAL",
      "description": "Detailed assessment of elevated integration scopes for Sandvik, building on earlier Teams and Power Platform work. It ensures only properly governed apps and permissions reach the production tenant.\n",
      "branchOnly": false,
      "parent": "SANDVIK-TPPA"
    },
    {
      "id": "BREXT-DOC",
      "level": "subitem",
      "title": "Browser Extension: DocumentScan",
      "year": 2026,
      "quarter": "Q1",
      "week": 1,
      "month": 10,
      "lane": "RND",
      "description": "A browser extension prototype that uses document scanning and file APIs to analyze on-screen content. It is intended to support quick classification, extraction and follow-up actions from within the browser.\n",
      "branchOnly": false,
      "parent": "BREXT, CI-FIN"
    },
    {
      "id": "BMO-CD",
      "level": "goal",
      "title": "BMO Coaching and Dispute - Phase 1",
      "year": 2025,
      "quarter": "Q2",
      "week": 2,
      "month": 3,
      "lane": "COMMERCIAL",
      "description": "The first phase of a BMO coaching and dispute platform derived from QA tooling patterns. It centralizes audit data, coaching notes and dispute workflows to improve accountability.\n",
      "branchOnly": false,
      "parent": "AUDITOOL"
    },
    {
      "id": "PROPERPAY-ICU",
      "level": "goal",
      "title": "ProperPay: ICU-DRG",
      "year": 2025,
      "quarter": "Q1",
      "week": 4,
      "month": 12,
      "lane": "INTERNAL",
      "description": "Integration of ICU and DRG-related logic into the ProperPay tool architecture. This merger allows richer cases and financial codes to be handled within the same automation.\n",
      "branchOnly": false,
      "image": "proper-pay.png",
      "parent": "PROPERPAY2"
    },
    {
      "id": "CI-QA",
      "level": "subitem",
      "title": "CI FIN - Audit Form",
      "year": 2025,
      "quarter": "Q2",
      "month": 1,
      "week": 2,
      "lane": "COMMERCIAL",
      "description": "CI Financial-specific QA audit forms based on the generic QA platform patterns. These forms standardize audit capture and enable better trend analysis.\n",
      "branchOnly": true,
      "parent": "AUDITOOL"
    },
    {
      "id": "KB-AA",
      "level": "subitem",
      "title": "Agentic Knowledge Assistant - Foresters KB Bot Improvements",
      "year": 2024,
      "quarter": "Q3",
      "week": 2,
      "month": 5,
      "lane": "INTERNAL",
      "description": "Enhancements to the Agentic Knowledge Assistant to better integrate with Foresters’ KB and authentication setup. The focus is on secure, context-aware recommendations that minimize manual searching.\n",
      "branchOnly": true,
      "image": "agentic-knowledge.png",
      "parent": "KNOWIT-AA"
    },
    {
      "id": "CI-MACRO",
      "level": "subitem",
      "title": "CI Macro Extraction",
      "year": 2025,
      "quarter": "Q2",
      "week": 2,
      "month": 2,
      "lane": "COMMERCIAL",
      "description": "Extraction and modernization of legacy Selenium-based macros for CI workflows. The outcome is an approved, supportable automation stack using updated Selenium and Python.\n",
      "branchOnly": true,
      "parent": "PT-MINER"
    },
    {
      "id": "BREXT-PSA",
      "level": "goal",
      "title": "Browser Extension: PSA",
      "year": 2025,
      "quarter": "Q2",
      "month": 4,
      "week": 1,
      "laneLevel": 1,
      "lane": "INTERNAL",
      "description": "A PSA browser extension that integrates with Entra ID and Graph APIs to assist with timesheet and PSA workflows. It is designed to securely act on behalf of users, reduce manual calculations and streamline submissions.\n",
      "branchOnly": false,
      "parent": "FY24RETRO",
      "image": "psa-browser-extension.png"
    },
    {
      "id": "ENVHACK",
      "level": "goal",
      "title": "Envision Hackathon Entry",
      "year": 2025,
      "quarter": "Q3",
      "week": 2,
      "month": 6,
      "lane": "TEAM",
      "description": "A team entry into the Envision Hackathon that reached the finalist stage with a Copilot-themed solution. It serves as both a learning lab and a showcase of D&AS creativity in the Microsoft ecosystem.\n",
      "branchOnly": false
    },
    {
      "id": "2025-Q4-sd-trainers",
      "level": "subitem",
      "title": "SD Trainers",
      "year": 2025,
      "quarter": "Q4",
      "week": 1,
      "month": 1,
      "laneLevel": 2,
      "lane": "RND",
      "description": "Exploration with academia or partners about trainers for service desk-related models or tools. It evaluates whether specialized training capabilities already exist or need to be built in-house.\n",
      "branchOnly": true,
      "parent": "ENVHACK"
    },
    {
      "id": "DAS-QA-INSTRUCT-2",
      "level": "goal",
      "title": "AI QA Expert System",
      "year": 2026,
      "quarter": "Q1",
      "month": 10,
      "week": 3,
      "laneLevel": 2,
      "lane": "FLAGSHIP",
      "icon": "rocket-flagship.svg",
      "description": "A QA platform for Shared Services built on the instruct-mode patterns proven with BMO. It centralizes audits, simplifies forms and enhances reporting for shared services engagements.\n",
      "branchOnly": true,
      "parent": "DAS-QA-INSTRUCT, BMO-AUDIT, AUDITOOL",
      "image": "qa-for-shared-services.png"
    },
    {
      "id": "IVR",
      "level": "subitem",
      "title": "Web Automation and IVR",
      "year": 2025,
      "quarter": "Q4",
      "week": 1,
      "month": 7,
      "laneLevel": 1,
      "lane": "RND",
      "description": "Experiments in linking web automation with IVR flows for internal or client scenarios. The work looks at how voice menus can trigger browser-based actions reliably and securely.\n",
      "branchOnly": true,
      "parent": "ENVHACK"
    },
    {
      "id": "DAS-WFM",
      "level": "subitem",
      "title": "WFM - CI/CD",
      "year": 2025,
      "month": 6,
      "week": 4,
      "quarter": "Q4",
      "lane": "INTERNAL",
      "description": "Application of CI/CD practices to Workforce Management-related solutions in collaboration with internal teams. It ensures deployments are repeatable, version-controlled and aligned with broader DevOps standards.\n",
      "branchOnly": true,
      "parent": "WFM"
    },
    {
      "id": "JEKYLL",
      "level": "goal",
      "title": "Frankies Box of Fun things - Code Name: Jekyll",
      "year": 2025,
      "quarter": "Q4",
      "week": 1,
      "month": 8,
      "lane": "RND",
      "description": "A static site generation approach using Markdown-to-web workflows under the Jekyll codename. It forms the basis for documentation, roadmaps and catalog sites that are easy to maintain via Git.\n",
      "branchOnly": false,
      "parent": "FY25RETRO",
      "image": "jekyll.png"
    },
    {
      "id": "BREXT-NMT",
      "level": "goal",
      "title": "Browser Extension - Translation Series",
      "year": 2025,
      "quarter": "Q4",
      "week": 1,
      "month": 5,
      "lane": "INTERNAL",
      "description": "A translation tool prototype for French-English content within D365 Finance and Operations. It addresses a client request for a reliable alternative to manual translation efforts.\n   A browser extension that evaluates French-to-English translation quality, e.g., for LVMH-like scenarios.\nIt helps decide whether in-house or third-party translation models can replace manual support.\n- Tool FrEn D365 Fo - FrEn Browser Extension\n",
      "branchOnly": false,
      "parent": "BREXT"
    },
    {
      "id": "AKA",
      "level": "goal",
      "title": "Agentic Knowledge Assistant (AKA)",
      "year": 2025,
      "quarter": "Q4",
      "week": 3,
      "month": 8,
      "lane": "FLAGSHIP",
      "icon": "rocket-flagship.svg",
      "description": "A production-ready Agentic Knowledge Assistant building on Valmet telemetry and Power Platform learnings. It aims to expand use cases, reduce reliance on competing vendors and deepen CGI’s footprint.\n",
      "branchOnly": true,
      "parent": "KB-AA"
    },
    {
      "id": "DAS-QA-INSTRUCT",
      "level": "goal",
      "title": "CAMS-SS: Audit and Coaching",
      "year": 2025,
      "quarter": "Q3",
      "month": 7,
      "week": 2,
      "lane": "internal",
      "description": "A CAMS-focused QA and coaching solution built on instruct-mode AI patterns. It aims to make audit forms self-contained, traceable and easier to analyze at scale.\n",
      "branchOnly": false,
      "parent": "AUDITOOL"
    },
    {
      "id": "FI-CTRL2",
      "level": "subitem",
      "title": "FI Controllership - Monthly IPS & Forecasting",
      "year": 2025,
      "quarter": "Q4",
      "week": 1,
      "month": 8,
      "lane": "COMMERCIAL",
      "description": "Automation and analytics for monthly IPS and forecasting activities within FI Controllership. It improves accuracy, reduces manual preparation and supports more timely financial decisions.\n",
      "branchOnly": true,
      "parent": "FI-CTRL"
    },
    {
      "id": "CC",
      "level": "goal",
      "title": "CI-Command Center",
      "year": 2025,
      "quarter": "Q4",
      "month": 9,
      "week": 1,
      "lane": "COMMERCIAL",
      "description": "A CI-focused command center dashboard consolidating telemetry, ETL outputs and key KPIs. It provides leadership with a live view of operations, issues and trends across CI work.\n",
      "branchOnly": false,
      "parent": "OBSERVABLE",
      "image": "command-center.png"
    },
    {
      "id": "DAS-SCRYER",
      "level": "goal",
      "title": "Scryer: Observability Platform",
      "year": 2026,
      "quarter": "Q1",
      "month": 10,
      "week": 1,
      "lane": "FLAGSHIP",
      "icon": "rocket-flagship.svg",
      "description": "CGI Scryer is a tool-agnostic observability platform that analyzes telemetry to reveal workflow patterns and bottlenecks. It empowers leaders to make data-driven decisions on staffing, tooling and process improvements.\n",
      "branchOnly": false,
      "parent": "TELEMETRY, CC",
      "image": "cgi-scryer.png"
    },
    {
      "id": "DAS-BREXT",
      "level": "goal",
      "title": "Browser Extension - Web Automation Offering",
      "year": 2026,
      "quarter": "Q1",
      "month": 10,
      "week": 4,
      "laneLevel": 2,
      "lane": "FLAGSHIP",
      "icon": "rocket-flagship.svg",
      "description": "A flagship packaging of browser extension capabilities as a formal web automation offering. It combines PSA helpers, KB tools and document scanners into a coherent story for clients. KT and Handover\n",
      "branchOnly": false,
      "parent": "AKA, BREXT-PSA, BREXT-NMT, BREXT-DOC"
    },
    {
      "id": "FY25RETRO",
      "level": "goal",
      "title": "FY25 Retrospective",
      "year": 2025,
      "quarter": "Q4",
      "month": 9,
      "week": 1,
      "lane": "VISION",
      "description": "A planned retrospective for FY25 that will capture commercial use cases, cost savings and internal improvements. It will anchor the narrative for FY26 planning and Leadership Connect sessions.\n",
      "branchOnly": false,
      "image": "fy25-q3-commercial-uses-cases.png"
    },
    {
      "id": "FY26LC",
      "level": "goal",
      "title": "FY26 Leadership Connect: Collaborative",
      "year": 2025,
      "quarter": "Q4",
      "month": 9,
      "week": 2,
      "laneLevel": 2,
      "lane": "VISION",
      "description": "Placeholder for the FY26 Leadership Connect theme with a likely focus on collaboration and co-creation. It will reflect the maturation of AI, observability and browser extension offerings into larger programs.\n",
      "branchOnly": false
    },
    {
      "id": "2025-Q1-ci-qa-forms",
      "level": "subitem",
      "title": "CI QA FORMS",
      "year": 2026,
      "quarter": "Q1",
      "month": 10,
      "week": 1,
      "lane": "COMMERCIAL",
      "description": "Implementation of QA forms tailored for CI teams using the same audit platform. This provides a consistent QA approach across multiple business units.\n",
      "branchOnly": true,
      "parent": "DAS-QA-INSTRUCT"
    },
    {
      "id": "JUMPSTART",
      "level": "goal",
      "title": "D&AS Jumpstart - One Stop shop",
      "year": 2026,
      "quarter": "Q1",
      "month": 12,
      "week": 1,
      "lane": "FLAGSHIP",
      "icon": "rocket-flagship.svg",
      "description": "A D&AS Jumpstart concept that turns repository Markdown into a one-stop documentation and roadmap site. It also envisions future features like pipeline catalogues and automation patch tracking.\n",
      "branchOnly": false,
      "parent": "JEKYLL"
    },
    {
      "id": "BMO-SD-AUDIT",
      "level": "subitem",
      "title": "BMO SD: QA-Forms",
      "year": 2026,
      "quarter": "Q1",
      "month": 10,
      "week": 2,
      "lane": "COMMERCIAL",
      "description": "QA forms adapted for BMO Service Desk scenarios based on the generic QA framework. They support structured audits and coaching for service desk agents.\n",
      "branchOnly": true,
      "parent": "DAS-QA-INSTRUCT"
    },
    {
      "id": "BREXT-OPMT",
      "level": "subitem",
      "title": "CI OPMT",
      "year": 2026,
      "quarter": "Q1",
      "month": 11,
      "week": 1,
      "lane": "COMMERCIAL",
      "description": "A browser extension-driven replacement for legacy macro-based OPMT automations at CI. It addresses Internet Explorer deprecation and ensures tasks remain automated in modern browsers.\n",
      "branchOnly": false,
      "parent": "DAS-BREXT"
    },
    {
      "id": "BREXT-RESP",
      "level": "subitem",
      "title": "CI FIN RESP Notional Calculation",
      "year": 2026,
      "quarter": "Q1",
      "month": 11,
      "week": 1,
      "lane": "COMMERCIAL",
      "description": "Automation to help CI FIN calculate RESP notional values using browser-based tools. It reduces manual spreadsheet work and ensures consistent application of business rules.\n",
      "branchOnly": false,
      "parent": "DAS-BREXT"
    },
    {
      "id": "PSA-BREXT-SERIES",
      "level": "goal",
      "title": "PSA: Browser Extension Series",
      "year": 2026,
      "quarter": "Q1",
      "month": 12,
      "week": 3,
      "lane": "FLAGSHIP",
      "icon": "rocket-flagship.svg",
      "description": "A procurement-focused browser extension to assist with repetitive web procurement tasks. It showcases how extension patterns can generalize beyond PSA and KB scenarios.\n",
      "branchOnly": false,
      "fanOut": true,
      "parent": "BREXT-PSA"
    },
    {
      "id": "BREXT-PROC",
      "level": "subitem",
      "title": "PSA Browser Extension: Procurement",
      "year": 2026,
      "quarter": "Q1",
      "lane": "INTERNAL",
      "description": "A procurement-focused browser extension to assist with repetitive web procurement tasks. It showcases how extension patterns can generalize beyond PSA and KB scenarios.\n",
      "branchOnly": true,
      "parent": "PSA-BREXT-SERIES"
    },
    {
      "id": "BREXT-MNGR",
      "level": "subitem",
      "title": "PSA Browser Extension: Approvers",
      "year": 2026,
      "quarter": "Q1",
      "lane": "INTERNAL",
      "description": "A manager-facing enhancement to the PSA browser extension to support approver flows. It aims to simplify review, approval and correction of timesheets directly from the browser extension UI.\n",
      "branchOnly": true,
      "parent": "PSA-BREXT-SERIES"
    },
    {
      "id": "BREXT-MNGR",
      "level": "subitem",
      "title": "PSA Browser Extension: Journal Entries",
      "year": 2026,
      "quarter": "Q1",
      "lane": "INTERNAL",
      "description": "A manager-facing enhancement to the PSA browser extension to support approver flows. It aims to simplify review, approval and correction of timesheets directly from the browser extension UI.\n",
      "branchOnly": true,
      "parent": "PSA-BREXT-SERIES"
    },
    {
      "id": "GHE",
      "level": "goal",
      "title": "Repository Migration to Github Enterprise",
      "year": 2026,
      "quarter": "Q1",
      "month": 12,
      "week": 1,
      "lane": "PROCESS",
      "description": "A migration effort moving repositories to GitHub Enterprise where governance and integration needs demand it. It follows the same principles as the Azure DevOps migration, emphasizing CI/CD and security.\n",
      "branchOnly": true,
      "fanout": false
    },
    {
      "id": "CFS",
      "level": "goal",
      "title": "Moving to Cloud-First Strategy",
      "year": 2026,
      "quarter": "Q2",
      "month": 1,
      "week": 1,
      "lane": "VISION",
      "description": "Moving all new developments and existing workloads to cloud platforms to leverage scalability, flexibility, and cost-efficiency. This shift supports modern application architectures and enhances disaster recovery capabilities.\n",
      "branchOnly": true,
      "fanout": false
    },
    {
      "id": "OPENAPI-SPEC",
      "level": "goal",
      "title": "Enabling Interoperability with OpenAPI Specifications",
      "year": 2026,
      "quarter": "Q2",
      "month": 2,
      "week": 1,
      "steps": 1,
      "image": "open-systems-architecture.png",
      "lane": "VISION",
      "description": "Adoption of OpenAPI specifications for all API developments to ensure standardization and ease of integration across services. This initiative promotes better collaboration with third-party developers and internal teams.\n",
      "branchOnly": true,
      "fanout": false
    },
    {
      "id": "AI-EXP-SYS-ENT",
      "level": "goal",
      "title": "AI Quality Audit Expert System",
      "year": 2025,
      "month": 12,
      "week": 3,
      "quarter": "Q2",
      "lane": "INTERNAL",
      "description": "Expansion of Workforce Management solutions to enterprise-wide applications. This includes integrating with larger HR systems and scaling WFM capabilities across multiple departments.\n",
      "branchOnly": true,
      "parent": "WFM, GHE, CFS, OPENAPI-SPEC"
    },
    {
      "id": "AI-QA-EXP-ENT",
      "level": "goal",
      "title": "AI QA Expert System - Enterprise",
      "year": 2026,
      "month": 1,
      "week": 3,
      "steps": 1,
      "quarter": "Q2",
      "lane": "PROCESS",
      "description": "Development of an AI-powered quality audit expert system for enterprise applications. This system leverages instruct-mode AI to streamline audit processes and enhance coaching capabilities across various business units.\n",
      "branchOnly": false,
      "parent": "DIGITAL-BPS"
    },
    {
      "id": "SCRYER-ENT",
      "level": "goal",
      "title": "SCRYER - Enterprise",
      "year": 2026,
      "month": 4,
      "week": 1,
      "quarter": "Q2",
      "lane": "INTERNAL",
      "description": "Expansion of Workforce Management solutions to enterprise-wide applications. This includes integrating with larger HR systems and scaling WFM capabilities across multiple departments.\n",
      "branchOnly": false,
      "parent": "DIGITAL-BPS"
    },
    {
      "id": "DAS-WFM-ENT",
      "level": "goal",
      "title": "WFM DIGITAL-BPS",
      "year": 2026,
      "month": 1,
      "week": 1,
      "quarter": "Q2",
      "lane": "INTERNAL",
      "description": "Expansion of Workforce Management solutions to enterprise-wide applications. This includes integrating with larger HR systems and scaling WFM capabilities across multiple departments.\n",
      "branchOnly": false,
      "parent": "DIGITAL-BPS"
    },
    {
      "id": "DAS-BREXT-ENT",
      "level": "goal",
      "title": "Browser Extension - Enterprise Offering",
      "year": 2026,
      "month": 2,
      "week": 4,
      "quarter": "Q2",
      "lane": "TEAM",
      "description": "Expansion of Workforce Management solutions to enterprise-wide applications. This includes integrating with larger HR systems and scaling WFM capabilities across multiple departments.\n",
      "branchOnly": false,
      "parent": "DIGITAL-BPS"
    },
    {
      "id": "DIGITAL-BPS",
      "level": "goal",
      "title": "DigitalBPS",
      "year": 2026,
      "month": 12,
      "week": 4,
      "quarter": "Q1",
      "lane": "FLAGSHIP",
      "icon": "rocket-flagship.svg",
      "description": "Implementation of DigitalBPS within D&AS to streamline business process services. This includes automating routine tasks and enhancing process visibility across teams.\n",
      "branchOnly": false,
      "parent": "GHE, CFS, OPENAPI-SPEC, DAS-SCRYER, DAS-WFM, AKA"
    },
    {
      "id": "QA-SELF-SERVE-FY26",
      "level": "goal",
      "title": "Self-Service, Operational Insights and Admin Tools",
      "year": 2026,
      "month": 2,
      "week": 1,
      "steps": 1,
      "quarter": "Q2",
      "lane": "PROCESS",
      "description": "⬜1. Self-Service feature for project owners ⬜2. Admin Page (3 Months) ⬜3. AI for Workforce & Operational Insights\n",
      "branchOnly": false,
      "parent": "AI-QA-EXP-ENT"
    },
    {
      "id": "QA-INTEROP-FY26",
      "level": "goal",
      "title": "Self-Service, Operational Insights and Admin Tools",
      "year": 2026,
      "month": 2,
      "week": 4,
      "steps": 2,
      "quarter": "Q2",
      "lane": "PROCESS",
      "description": "⬜1. Seamless data sourcing (Integration for different sources) (3 weeks) ⬜2. Plug and Play of Engagements (3 Months)\n",
      "bbranchOnly": false,
      "parent": "AI-QA-EXP-ENT"
    },
    {
      "id": "QA-INSTRUCT-FY26",
      "level": "goal",
      "title": "Quality Assurance & Coaching extended AI capabilities",
      "year": 2026,
      "month": 3,
      "week": 3,
      "steps": 3,
      "quarter": "Q2",
      "lane": "PROCESS",
      "description": "⬜1. Auto Review of Ticket (Transcripts, Calls, Emails, etc.) ⬜2. Identify weakness agent for proper coaching endorsement ⬜3. Initial coaching (recommendations after review of ticket) ⬜4. Realtime auditing of calls (to provide solutions and recommendations after the call) ⬜5. Automated QA (On-the-day QA) ⬜6. After Call QA ⬜7. After Ticket Creation (or Resolution) (Not sure – depends on data source and process) ⬜8. Bulk Audit (Scheduled or import)\n",
      "branchOnly": false,
      "parent": "AI-QA-EXP-ENT"
    },
    {
      "id": "DAS-BREXT-FY26",
      "level": "goal",
      "title": "R&D and Offering Expansion",
      "year": 2026,
      "month": 4,
      "week": 3,
      "steps": 0,
      "quarter": "Q3",
      "lane": "TEAM",
      "description": "⬜1. Automation Development ⬜2. Compoments Development Handover ⬜3. Document Processors and Parsers ⬜4. Singal Processors and Syntesisers ⬜5. WASM ⬜6. Browser Based AI Models\n",
      "branchOnly": false,
      "parent": "DAS-BREXT-ENT"
    },
    {
      "id": "DAS-BREXT-PSA-FY26",
      "level": "goal",
      "title": "PSA Series Expansion",
      "year": 2026,
      "month": 5,
      "week": 3,
      "steps": 1,
      "quarter": "Q3",
      "lane": "TEAM",
      "description": "⬜ Project Service Automation Enhancements\n",
      "bbranchOnly": true,
      "parent": "DAS-BREXT-ENT"
    },
    {
      "id": "DAS-BREXT-TR-FY26",
      "level": "goal",
      "title": "Translation Series Expansion",
      "year": 2026,
      "month": 6,
      "week": 1,
      "steps": 2,
      "quarter": "Q3",
      "lane": "TEAM",
      "description": "⬜1. Other Multilingual Translations (Spanish, German, Italian, etc.) ⬜2. Document Translation\n",
      "branchOnly": false,
      "parent": "DAS-BREXT-ENT"
    },
    {
      "id": "DAS-BREXT-RD1-FY26",
      "level": "goal",
      "title": "Frankie's Box of Fun things - Code Name: Magenetic",
      "year": 2026,
      "month": 6,
      "week": 3,
      "steps": 2,
      "quarter": "Q3",
      "lane": "TEAM",
      "description": "PersonaL R&D for Browser Extension\n",
      "branchOnly": false,
      "parent": "DAS-BREXT-ENT"
    },
    {
      "id": "DAS-BREXT-RD2-FY26",
      "level": "goal",
      "title": "Frankie's Box of Fun things - Code Name: Repulsion",
      "year": 2026,
      "month": 7,
      "week": 3,
      "steps": 2,
      "quarter": "Q3",
      "lane": "TEAM",
      "description": "PersonaL R&D for Browser Extension\n",
      "branchOnly": false,
      "parent": "DAS-BREXT-ENT"
    },
    {
      "id": "SC-EXPANSION-FY26",
      "level": "goal",
      "title": "Engagement Expansion & Coverage Enhancement",
      "year": 2026,
      "month": 5,
      "week": 2,
      "steps": 2,
      "quarter": "Q2",
      "lane": "INTERNAL",
      "description": "⬜1. Telemetry Deployable Package ⬜2. Telemetry Coverage Expansion ⬜3. Grafana Alerts & Notification Framework ⬜4. Advanced Journey Views (UX/Behavior Focus)\n",
      "branchOnly": false,
      "parent": "SCRYER-ENT"
    },
    {
      "id": "SC-INSIGHT-WORKFLOW-FY26",
      "level": "goal",
      "title": "Insight Layer & Workflow Analytics",
      "year": 2026,
      "month": 5,
      "week": 4,
      "steps": 2,
      "quarter": "Q2",
      "lane": "INTERNAL",
      "description": "⬜1. Workflow Inefficiency Detection (Rule-Based Engine) ⬜2. Task Sequence Recognition workflow mining–level insights with only rule-based logic. ⬜3. Single-User & Team Summary Reports\n",
      "branchOnly": false,
      "parent": "SCRYER-ENT"
    },
    {
      "id": "SC-LIGHT-AI-MODEL-FY26",
      "level": "goal",
      "title": "Lightweight AI Enhancement",
      "year": 2026,
      "month": 6,
      "week": 3,
      "steps": 1,
      "quarter": "Q3",
      "lane": "INTERNAL",
      "description": "⬜1. Behavior Clustering (KMeans) ⬜2. Productivity Profile Prediction ⬜3. Suggestion Engine (Rule + ML Hybrid) ⬜4. Anomaly Detection (Isolation Forest) ⬜5. Trend Analysis & Forecasting (Time Series) ⬜6. Worforce within schedule Prediction - Automated Shift Scheduling ⬜7. PSA Time Entry drafting ⬜8. Automated Task Prioritization\n",
      "branchOnly": false,
      "parent": "SCRYER-ENT"
    },
    {
      "id": "SC-CCME-FY26",
      "level": "goal",
      "title": "Command Center & Multi-Engagement Visibility",
      "year": 2026,
      "month": 7,
      "week": 1,
      "steps": 2,
      "quarter": "Q3",
      "lane": "INTERNAL",
      "description": "⬜1. Multi-Engagement Command Center ⬜2. Health & Deployment Monitoring ⬜3. Telemetry for Automation \n",
      "branchOnly": false,
      "parent": "SCRYER-ENT"
    },
    {
      "id": "SC-DGSED-FY26",
      "level": "goal",
      "title": "Data Governance,Security Enhancements and Democratisation",
      "year": 2026,
      "month": 8,
      "week": 3,
      "steps": 0,
      "quarter": "Q2",
      "lane": "INTERNAL",
      "description": "⬜1. Data Privacy & Compliance Framework ⬜2. Role-Based Access Control (RBAC) ⬜3. Data Lineage & Audit Trails ⬜4. Self-Service Data Access Portal\n",
      "branchOnly": false,
      "parent": "SCRYER-ENT"
    },
    {
      "id": "SC-VIZ-FY26",
      "level": "goal",
      "title": "Advanced Visualization & Reporting",
      "year": 2026,
      "month": 9,
      "week": 2,
      "steps": 0,
      "quarter": "Q3",
      "lane": "INTERNAL",
      "description": "⬜1. Customizable Dashboards ⬜2. Advanced Reporting Tools ⬜3. Advanced Visualization Techniques (Heatmaps, Sankey Diagrams)\n",
      "branchOnly": false,
      "parent": "SCRYER-ENT"
    }
  ]
}